import { useTranslation } from 'react-i18next';
import { Course } from '../../../../../../types/psychometric';
import CourseItem from './CourseItem';

interface CourseSectionProps {
  courses: Course[];
}

export function CourseSection({ courses }: CourseSectionProps) {
  const { t } = useTranslation();
  if (!courses?.length) return null;

  return (
    <div className="tc-mv-question-field p-4 rounded-2xl text-white space-y-2">
      <h2 className="text-xl font-semibold">{t('profile.courses')}</h2>
      <div className="space-y-8">
        {courses.map((Course, index) => (
          <CourseItem key={index} course={Course} />
        ))}
      </div>
    </div>
  );
}
